@if (!object()) {
  <a [class.disabled]="disabled()">
    <cl-icon
      [icon]="icon()"
      [size]="size()" />
    @if (notificationsCount()) {
      <span class="notificationsCount">
        {{ notificationsCount() }}
      </span>
    }
  </a>
} @else {
  <a [class.disabled]="disabled()">
    <object
      type="image/svg+xml"
      data="/assets/icons/bell-blue-2.svg"
      [style.width]="size()">
      <img
        aria-hidden="true"
        src="/assets//icons/bell-blue-2.svg"
        [alt]="'Badge icon.' | translate"
        [style.width]="size()" />
    </object>
    @if (notificationsCount()) {
      <span class="notificationsCount">
        {{ notificationsCount() }}
      </span>
    }
  </a>
}
